import {MemberFirmVisitorVisaTypeEnum} from '@employee-models/data.enums';

export const VISA_TYPE: Array<{ name: string, id: MemberFirmVisitorVisaTypeEnum }> = [
    {
        name: 'Business',
        id: MemberFirmVisitorVisaTypeEnum.Business
    },
    {
        name: 'e-Business',
        id: MemberFirmVisitorVisaTypeEnum.EBusiness
    },
    {
        name: 'e-Tourist',
        id: MemberFirmVisitorVisaTypeEnum.ETourist
    },
    {
        name: 'Employment',
        id: MemberFirmVisitorVisaTypeEnum.Employment
    },
    {
        name: 'Resident',
        id: MemberFirmVisitorVisaTypeEnum.Resident
    },
    {
        name: 'Tourist',
        id: MemberFirmVisitorVisaTypeEnum.Tourist
    },
];
